<br>
<div class="divflex height30px">
  <div class="tabStyle">
    <div class="tabStyleHeader">Inorganic&nbsp;{{(impuritiesInorganicIndex+1)}}</div>
  </div>
  <div class="padleft105px margintopneg10px">
    <button mat-icon-button color="primary" (click)="confirmDeleteImpuritiesInorganic()"
      matTooltip="Delete Inorganic Impurities {{impuritiesInorganicIndex + 1}}">
      <mat-icon>delete_forever</mat-icon>
    </button>
  </div>
</div>

<mat-card class="bordergray">
  <mat-card-content>
    <div class="flex-container marginleftneg7px padbottom10px">

      <!-- Left Side -->
      <div class="width25percent textaligncenter"  *ngIf="configSettingsDisplay['relatedSubstanceUnii'] || (configSettingsDisplay['relatedSubstanceUnii'] === undefined && true)">
        <app-substance-selector class="textaligncenter" (selectionUpdated)="relatedSubstanceUpdated($event)"
          eventCategory="substanceRelationshipRelatedSub" placeholder="Substance Name" [hideImage]="false"
          header="Related Substance" [subuuid]="impuritiesInorganic.relatedSubstanceUuid" [showMorelinks]=true>
        </app-substance-selector>
        <div class="textaligncenter font11px" *ngIf="impuritiesInorganic.relatedSubstanceUnii">
          {{impuritiesInorganic.relatedSubstanceUnii}}
        </div>
      </div>

      <!-- Right Side -->
      <div class="flex-item width75percent padleft20px padright20px">

        <div class="form-row">
          <app-cv-input class="col-3-1"  *ngIf="configSettingsDisplay['testType'] || (configSettingsDisplay['testType'] === undefined && true)"
          domain="IMPURITIES_TEST_TYPE" title="Test Type" name="testType"
            [model]="impuritiesInorganic.testType" (valueChange)="impuritiesInorganic.testType = $event">
          </app-cv-input>

          <app-cv-input class="col-3-1" 
          *ngIf="configSettingsDisplay['limitType'] || (configSettingsDisplay['limitType'] === undefined && true)"
          domain="IMPURITIES_LIMIT_TYPE" title="Limit Type" name="limitType"
            [model]="impuritiesInorganic.limitType" (valueChange)="impuritiesInorganic.limitType = $event">
          </app-cv-input>

          <mat-form-field class="col-3-1"
          *ngIf="configSettingsDisplay['limitValue'] || (configSettingsDisplay['limitValue'] === undefined && true)">
            <input matInput placeholder="Limit Value" [(ngModel)]="impuritiesInorganic.limitValue" name="limitValue" />
          </mat-form-field>

        </div>

        <div class="form-row">
          <app-cv-input class="col-3-1" 
          *ngIf="configSettingsDisplay['unit'] || (configSettingsDisplay['unit'] === undefined && true)"
          domain="PROD_UNIT" title="Unit" name="unit" [model]="impuritiesInorganic.unit"
            (valueChange)="impuritiesInorganic.unit = $event">
          </app-cv-input>

          <mat-form-field class="col-3-2"
          *ngIf="configSettingsDisplay['comments'] || (configSettingsDisplay['comments'] === undefined && true)">
            <textarea matInput placeholder="Comments" [(ngModel)]="impuritiesInorganic.comments" name="comments"
              rows="1"></textarea>
          </mat-form-field>
        </div>

      </div>
      <!-- Right Side -->


    </div>

  </mat-card-content>
</mat-card>